// extracted by mini-css-extract-plugin
export default {"container":"StakingPositionsList_container__dNvdJ","alert":"StakingPositionsList_alert__dzbmr"};